import React from 'react';
import { useNavigate } from 'react-router-dom';
interface PersonaCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  path: string;
}
const PersonaCard: React.FC<PersonaCardProps> = ({
  title,
  description,
  icon,
  path
}) => {
  const navigate = useNavigate();
  return <div onClick={() => navigate(path)} className="flex text-center flex-col items-center p-8 bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md hover:border-primary-500 transition-all cursor-pointer h-full" data-id="element-292">
      <div className="w-16 h-16 flex items-center justify-center text-primary-500 mb-4" data-id="element-293">
        {icon}
      </div>
      <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-294">{title}</h3>
      <p className="text-gray-600 text-center" data-id="element-295">{description}</p>
    </div>;
};
export default PersonaCard;